import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f63dc384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule-table-wrapper" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n        日付をタップして働きたい日を登録すると、オファーが届きやすくなります\n      ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, "\n        ※ お気に入りしている事業所のみに公開されます\n      ", -1))

import { accountService } from "@/app/services/AccountService";
import { orderService } from "@/app/services/OrderService";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import Calendar from "@/components/organisms/desired_work_schedules/Calendar.vue";
import ScheduleFormBottomSheet from "@/components/organisms/desired_work_schedules/ScheduleFormBottomSheet.vue";
import SuggestOrderModal from "@/components/organisms/desired_work_schedules/SuggestOrderModal.vue";
import router from "@/router";
import { masterStore } from "@/store/master";
import { DesiredWorkSchedule } from "@/types/desired_work_schedule/DesiredWorkSchedule";
import { SlimOrder } from "@/types/order/Order";
import {
  addMonths,
  endOfMonth,
  formatFromUnixTimestamp,
  now
} from "@/utils/date";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { captureException } from "@sentry/vue";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredWorkSchedule',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();

const selectedDate = ref<string | null>(null);
const isBottomSheetVisible = ref<boolean>(false);
const suggestOrderModalVisible = ref<SlimOrder | null>(null);
const selectedSchedules = ref<DesiredWorkSchedule[]>([]);
const suggestionOrders = ref<SlimOrder[]>([]);
// おすすめ案件モーダルはこのカウンターが3の倍数の時にランダムで表示する
const suggestOrderModalCounter = ref<number>(0);

onMounted(async () => {
  try {
    loader.show();
    const [schedules, orders] = await Promise.all([
      accountService.fetchDesiredWorkSchedules(),
      fetchSuggestionOrders()
    ]);
    selectedSchedules.value = schedules;
    suggestionOrders.value = orders;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const holidays = computed(() => {
  return masterStore.japaneseHolidays.map(holiday => holiday.date);
});

async function fetchSuggestionOrders() {
  const favoritedOffice = await accountService.fetchFavoriteOffices();
  const currentTime = now();
  const today = formatFromUnixTimestamp(currentTime, "yyyy-MM-dd");
  const endOfDateMonthAfterNext = formatFromUnixTimestamp(
    endOfMonth(addMonths(currentTime, 2)),
    "yyyy-MM-dd"
  );

  const orders = await orderService.searchOrdersByOfficeIds({
    office__in: favoritedOffice.results
      .map(office => office.office.id)
      .join(","),
    date__gte: today,
    date__lte: endOfDateMonthAfterNext
  });
  return orders;
}

const dayClick = (calendarDay: string) => {
  selectedDate.value = calendarDay;
  isBottomSheetVisible.value = true;
};

const closeBottomSheet = () => {
  selectedDate.value = null;
  isBottomSheetVisible.value = false;
};

function onClickBack() {
  router.back();
}

function showSuggestOrderModal(selectedDate: string) {
  if (suggestOrderModalCounter.value % 3 !== 0) {
    suggestOrderModalCounter.value++;
    return;
  }

  if (Math.random() > 0.33) {
    return;
  }

  // 該当日付の案件を取得
  const orders = suggestionOrders.value.filter(
    order => order.date === selectedDate
  );
  if (orders.length > 0) {
    suggestOrderModalVisible.value = orders[0];
  }
  suggestOrderModalCounter.value++;
}

const onClickSave = async (schedule: {
  date: string;
  isAllDay: boolean;
  startAt: string | null;
  finishAt: string | null;
}) => {
  try {
    loader.show();
    const schedules = await accountService.updateDesiredWorkSchedule(schedule);
    selectedSchedules.value = schedules;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }

  closeBottomSheet();

  try {
    await showSuggestOrderModal(schedule.date);
  } catch (e) {
    await captureException(e);
  }
};

const onClickDelete = async (date: string) => {
  try {
    loader.show();
    const schedules = await accountService.deleteDesiredWorkSchedule(date);
    selectedSchedules.value = schedules;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }

  closeBottomSheet();
};

const onCloseSuggestOrderModal = () => {
  suggestOrderModalVisible.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      働きたい日\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Calendar, {
        desiredWorkSchedules: selectedSchedules.value,
        holidays: holidays.value,
        onDayClick: dayClick
      }, null, 8, ["desiredWorkSchedules", "holidays"]),
      _createTextVNode(),
      _hoisted_2,
      _createTextVNode(),
      _hoisted_3,
      _createTextVNode(),
      _hoisted_4
    ]),
    _createTextVNode(),
    _createVNode(ScheduleFormBottomSheet, {
      visible: isBottomSheetVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isBottomSheetVisible).value = $event)),
      selectedDate: selectedDate.value,
      selectedSchedules: selectedSchedules.value,
      onSave: onClickSave,
      onDelete: onClickDelete
    }, null, 8, ["visible", "selectedDate", "selectedSchedules"]),
    _createTextVNode(),
    _createVNode(SuggestOrderModal, {
      order: suggestOrderModalVisible.value,
      onClose: onCloseSuggestOrderModal
    }, null, 8, ["order"])
  ]))
}
}

})